import React from 'react'
import Sections from '../../components/Sections'
import MainLayout from '../../components/MainLayout'
import TopHero from '../../components/Sections/TopHero'
import Content from '../../components/Sections/Content'
import { get } from 'lodash'
import TearForm from '../../components/TearForm'
import { hyphenate } from '../../utils'

const Page = ({ data, pageContext }) => {
  const isHomepage = pageContext.is_homepage
  let topHeroContent
  let hasTopHeroImage
  let hasTopHeroVideo

  if (!isHomepage) {
    topHeroContent = {
      video: get(data, 'wordpressPage.acf.video.source_url', null),
      mobileImage: get(data, 'wordpressPage.acf.mobile_image.source_url', null),
      image: get(
        data,
        'wordpressPage.acf.image.localFile.childImageSharp.fluid',
        null
      ),
      title: get(data, 'wordpressPage.acf.title', ''),
      paragraph: get(data, 'wordpressPage.acf.paragraph', ''),
    }

    hasTopHeroImage = !!topHeroContent.image
    hasTopHeroVideo = !!topHeroContent.video
  }

  const contentData = get(data, 'wordpressPage', {})
  const sections = get(data, 'wordpressPage.acf.sections_page', [])

  const description = contentData.acf.meta_description ? contentData.acf.meta_description : null
  const image =
    data.wordpressPage.acf.meta_image?.localFile?.url ??
    data.wordpressPage?.acf?.image?.localFile?.url

  const metaData = {
    'title': contentData?.acf.meta_title,
    'keywords': contentData.acf.keywords,
    'description': description,
    'image': image,
  }

  const isSlitPage = data?.wordpressPage?.slug === 'tilkynna-slit'

  return (
    <MainLayout
      topSpacing={!isHomepage && (!hasTopHeroImage || !hasTopHeroVideo)}
      pageId={data?.wordpressPage?.wordpress_id}
      metaData={metaData}
    >
      {!isHomepage && (hasTopHeroImage || hasTopHeroVideo) && (
        <TopHero {...topHeroContent} />
      )}
      {/* TODO: when the backend can be updated again, remove this and make Tilkynna slit its own template like lagnateikningar */}
      {isSlitPage && (
        <div className='container'>
          <div className='row pt-5'>
            <div className='col-md-12 col-lg-10'>
              {contentData.title && <h1>{hyphenate(contentData.title)}</h1>}
              <article>
                <h4>Ef grafið er í ljósleiðaralögn svo slit verður á lögninni er mjög mikilvægt að tilkynna það strax.</h4>
                <p>Fylltu út í formið með upplýsingum um heimilisfang og hvað var verið að framkvæma. Sendu okkur endilega mynd af slitinu í viðhengi.</p>
              </article>
            </div>
          </div>
          <div style={{ marginLeft: '-1.7rem' }}>
            <TearForm />
          </div>
        </div>
      )}
      {contentData.content && <Content content={contentData.content} title={isSlitPage ? null : contentData.title} />}
      <Sections sections={sections} />
    </MainLayout>
  )
}

export default Page
